import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { debounce } from 'lodash';
import { fireResizeEventOnWindow } from '../utils/helpers';

class AutoHeight extends Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 50,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onWindowResize);
  }

  componentDidUpdate() {
    setTimeout(() => this.updateHeight() && fireResizeEventOnWindow()); // Wait things to settle before updating height
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  onWindowResize = debounce(() => this.updateHeight(), 150);

  updateHeight() {
    if (!this.wrapper || this.state.height === this.wrapper.clientHeight) return false;
    this.setState({ height: this.wrapper.clientHeight });
    return true;
  }

  render() {
    if (!this.props.children) return null;
    return (
      <div
        className="c-autoheight"
        style={{ height: this.state.height }}
      >
        <div ref={(ref) => { this.wrapper = ref; }}>
          { this.props.children }
        </div>
      </div>
    );
  }
}
AutoHeight.propTypes = {
  children: PropTypes.node,
};
AutoHeight.defaultProps = {
  children: null,
};

export default AutoHeight;




// WEBPACK FOOTER //
// ./src/app/components/AutoHeight.jsx